import axios from "axios";

const GUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isLikelyTournamentGuid(value) {
  return typeof value === "string" && GUID_RE.test(value.trim());
}

/**
 * Resuelve un identificador de ruta (GUID, slug público o código de compartir) al Id del torneo.
 */
export async function resolveTournamentIdFromPublicRoutes(apiBaseUrl, routeKey) {
  if (!routeKey || typeof routeKey !== "string") return null;
  const key = routeKey.trim();
  if (!key) return null;
  if (isLikelyTournamentGuid(key)) return key;

  const enc = encodeURIComponent(key);
  const base = String(apiBaseUrl || "").replace(/\/$/, "");

  try {
    const res = await axios.get(`${base}/api/public/tournaments/${enc}`);
    const id = res.data?.id ?? res.data?.Id;
    return id ? String(id) : null;
  } catch {
    // slug no encontrado o no público: probar enlace compartido
  }

  try {
    const res = await axios.get(`${base}/api/public/tournaments/shared/${enc}`);
    const id = res.data?.id ?? res.data?.Id;
    return id ? String(id) : null;
  } catch {
    return null;
  }
}
